import { createSlice } from '@reduxjs/toolkit'

export const deviceSlice = createSlice({
    name: 'device',
    initialState: {
      lowPowerModeStatus: null,
      isDetectionComplete: false,
      detectionError: null,
    },
    reducers: {
      setLowPowerModeStatus: (state, action) => {
        state.lowPowerModeStatus = action.payload;
        state.isDetectionComplete = true;
        state.detectionError = null;
      },
      setDetectionError: (state, action) => {
        state.detectionError = action.payload;
        state.isDetectionComplete = true;
        // Set safe defaults on error
        state.lowPowerModeStatus = {
          isLowPowerMode: false,
          isIOSDevice: false,
          deviceType: 'unknown',
          detectionTime: 0,
          timestamp: Date.now()
        };
      },
      resetDeviceState: (state) => {
        state.lowPowerModeStatus = null;
        state.isDetectionComplete = false;
        state.detectionError = null;
      },
      startDetection: (state) => {
        state.isDetectionComplete = false;
        state.detectionError = null;
      }
    },
})

// Action creators are generated for each case reducer function
export const { 
  setLowPowerModeStatus, 
  setDetectionError, 
  resetDeviceState,
  startDetection 
} = deviceSlice.actions

export default deviceSlice.reducer